/**
 * Dynamic Price Breaks for Pen Refills
 * Updates the price display and side message based on Metaobject data
 */
function initPriceBreaks() {
  const wrapper = document.querySelector('.price-breaks-flex-wrapper');
  const qtyInput = document.querySelector('input[name="quantity"]');
  const priceDataEl = document.querySelector('[id^="MetaPriceBreaks-"]');
  const priceContainer = document.querySelector('.f-price');
  const sideMsg = document.getElementById('price-breaks-applied-msg');

  if (!wrapper || !priceDataEl || !priceContainer) return;

  const data = JSON.parse(priceDataEl.textContent);
  const priceBreaks = data.breaks;
  const availability = data.variantAvailability;

  // 1. Function to show/hide the chart based on stock
  const toggleVisibility = () => {
    const urlParams = new URLSearchParams(window.location.search);
    let currentId = urlParams.get('variant');

    if (!currentId) {
      const idInput = document.querySelector('input[name="id"]');
      currentId = idInput ? idInput.value : null;
    }

    if (currentId && availability[currentId] === false) {
      wrapper.style.display = 'none';
    } else {
      wrapper.style.display = 'flex';
    }
  };

  // 2. Function to handle price math
  const updatePrice = () => {
    const qty = parseInt(qtyInput.value) || 1;
    const applicableBreak = [...priceBreaks]
      .sort((a, b) => b.min - a.min)
      .find(b => qty >= b.min);

    if (!applicableBreak) return;

    if (applicableBreak.min === 1) {
      priceContainer.classList.remove('f-price--on-sale');
      const regularPriceItem = priceContainer.querySelector('.f-price__regular .f-price-item--regular');
      if (regularPriceItem) regularPriceItem.innerText = applicableBreak.formatted;
      if (sideMsg) sideMsg.classList.remove('is-visible');
    } else {
      priceContainer.classList.add('f-price--on-sale');
      const salePriceItem = priceContainer.querySelector('.f-price__sale .f-price-item--sale');
      const strikeThroughItem = priceContainer.querySelector('.f-price__sale s');
      
      if (salePriceItem) salePriceItem.innerText = applicableBreak.formatted;
      if (strikeThroughItem) strikeThroughItem.innerText = priceBreaks[0].formatted;
      if (sideMsg) sideMsg.classList.add('is-visible');
    }
  };

  // Listen for quantity changes
  qtyInput.addEventListener('input', updatePrice);
  qtyInput.addEventListener('change', updatePrice);

  // Listen for variant changes (URL changes)
  window.addEventListener('popstate', () => {
    toggleVisibility();
    updatePrice();
  });

  // Watch for clicks on variant buttons/dropdowns
  document.addEventListener('change', (e) => {
    if (e.target.matches('[name="id"], .variant-input input, .product-form__input input')) {
      // Small timeout to allow theme to update the DOM
      setTimeout(() => {
        toggleVisibility();
        updatePrice();
      }, 50);
    }
  });

  // Initial Run
  toggleVisibility();
  updatePrice();
}

document.addEventListener('DOMContentLoaded', initPriceBreaks);
document.addEventListener('shopify:section:load', initPriceBreaks);